<template>
  <div class="mine-wrapper" ref="wrapper">
    <div class="page mine">
      <!-- 只是为了兼容在APP内的情况 -->
      <!-- <navigation adaption/> -->
      <div class="user-info" :class="memberIcon.length < 1 && 'height300'">
        <div class="info-card">
          <img class="avatar" src="./images/avatar.png" />
          <span class="mobile" v-if="creditStatus !== 'UN_LOGIN'">{{
            userInfo.mobile | mobile
          }}</span>
         
          <div class="question" @click="openCallDialog" v-if="creditStatus !== 'UN_LOGIN'">
            <img src="./images/icon_kefu@2x.png" alt="" />
            <div class="button">
              联系客服
            </div>
          </div>

          <div class="login-out" @click="logoutVisible = true" v-if="creditStatus !== 'UN_LOGIN'">
            <img src="./images/icon_tuichu.png" alt="" />
            <div class="button">
              退出登录
            </div>
          </div>

          <div class="to-login" v-if="creditStatus === 'UN_LOGIN'" @click="goLogin">
            登录/注册
          </div>
        </div>
      </div>
      <template v-if="!isQlc">
        <van-swipe v-if="memberIcon.length > 0" class="banner" :autoplay="3000" :duration="500" :show-indicators="false" @change="onBannerChange">
          <van-swipe-item v-for="(item, index) in memberIcon" :class="`caseId-${item.caseId}`" :key="index" data-sensors-exposure-event-name="Element_Exposure" :data-sensors-exposure-property-caseId="item.caseId" data-sensors-click @click="goMember(item.url, index)">
            <div class="swipe-item">
              <img :src="item.icon" alt="" />
            </div>
          </van-swipe-item>
          <div class="indicator" slot="indicator" v-if="memberIcon.length > 1 && false">
            <div class="indicator-item" :class="{ active: index === activeBanner }" v-for="(item, index) in memberIcon" :key="index"></div>
          </div>
        </van-swipe>
      </template>
      <div class="content">
        <div class="items">
          <div class="services">服务专区</div>
          <div class="item-list">
            <div class="item" v-for="(item, index) in newItemList" :key="index" @click="item.action">
              <img :src="item.icon" data-sensors-click class="services-image" />
              <p class="name" data-sensors-click :class="index === 2 && totalAmount ? 'item-point' : ''">
                {{ item.name }}
              </p>
            </div>
            <div class="item" data-sensors-exposure-event-name="Element_Exposure" data-sensors-exposure-property-caseId="onshare" data-sensors-click @click="$router.push('/actvie/share')" v-if="showOwn === 'Y'">
              <div class="lottie-image"><vue-lottie :options="lottieOptions"></vue-lottie></div>
              <p class="name">推荐有奖</p>
            </div>

            <div class="item" @click="$router.push('/message/list')" v-if="messageCenterVisible==='Y'">
              <img :src="require('./images/icon_xiaoxi.png')" data-sensors-click class="services-image" />
              <p class="name" data-sensors-click >
                消息中心
              </p>
              <div class="item-count" v-if="messageCount>0">{{ messageCount }}</div>
            </div>

          </div>
        </div>

        <div class="aboutMine">
          <!-- 插队申请（至尊王卡）浮标入口已下线 -->
          <!-- <div class="skc-point"></div> -->
          <nd-cell class="navigate-item" v-for="(item, index) in protocolList" :key="index" :title="item.title" @click="item.action">
          </nd-cell>
        </div>

        <!-- 关注公众号提示 -->
        <nd-follow class="mt20" v-if="userInfo.subscribe === 0"></nd-follow>

        <div class="support"  >
          
        </div>
      </div>
      <!-- 联系客服弹窗框 -->
      <nd-dialog v-model="serviceVisible" @confirm="callService" @close="closeDialog">
        <div class="service-dialog">
          <div class="title">联系客服</div>
          <div class="description">拨打客服电话进行咨询</div>
          <div class="description1">客服电话：4000100008</div>
          <div class="telphone">服务时间：</div>
          <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
        </div>
      </nd-dialog>

      <!-- 退出登录弹窗 -->
      <nd-dialog v-model="logoutVisible" @confirm="logout">
        <div class="logout-dialog">
          <div class="title">退出账号</div>
          <div class="description">确定退出天美贷吗？</div>
        </div>
      </nd-dialog>

      <nd-tabbar  ></nd-tabbar>
      <!-- 小美王卡（插队申请浮标）入口已下线 -->
      <!-- <skc id="drag" v-if="showSkc && floatInfo.kingFloat && floatInfo.kingFloat.kingFloatTitle" :kingFloatTitle="floatInfo.kingFloat.kingFloatTitle" :kingGoodsCd="floatInfo.kingFloat.kingGoodsCd"></skc> -->
      <dialog-back v-model="dialogBackVisible"></dialog-back>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { Swipe, SwipeItem } from 'vant'
import { mockHrefJump, getKey, setKey } from '../../assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import DialogBack from '../home/components/dialog-back'
import CountDownTool from '@/assets/CountDownTool'

import VueLottie from 'vue-lottie'
import invite from '@/assets/json/icon_invite.json'

export default {
  name: 'mine',

  customReadyNotify: true,
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    // 插队申请（至尊王卡）浮标入口已下线
    // skc: () => import('@/components/nd-drag-skc'),
    VueLottie,
    DialogBack
  },
  data () {
    return {
      lottieOptions: {
        animationData: invite, loop: true
      },
      showCouponGif: true,
      // 插队申请（至尊王卡）浮标入口已下线
      // floatInfo: {},
      // showSkc: false,
      memberGoodsCd: '',
      dialogBackVisible: false,
      activeBanner: 0,
      serviceVisible: false,
      logoutVisible: false,
      customerServicePhone: '4000100008',
      isWelfare: false,
      showCouponV3Mark: 'N',
      showOwn: 'N', // 是否展示老带新活动图标
      showVipBanner: false, // vip banner的显示与否
      memberIcon: [], // 小美图片展示
      messageCount: 0,
      vipStatus: '' // vip类型
    }
  },

  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo,
      guessLikeVisible: (state) => state.guessLikeVisible,
      rightsCenterVisible: (state) => state.rightsCenterVisible,
      creditStatusNew: (state) => state.quotaInfo.creditStatus,
      threeRepayVisible: (state) => state.threeRepayVisible,
      couponPacksVisible: (state) => state.couponPacksVisible,
      welfareCenterVisible: (state) => state.welfareCenterVisible,
      messageCenterVisible: (state) => state.messageCenterVisible,
      feedbackVisible: (state) => state.feedbackVisible,
      monitor: (state) => state.monitor
    }),
    protocolList () {
      const _list = [
        { title: '账号与安全', action: this.goToAccountAndSecurity }       
        // { title: '关于我们', action: this.goAbout },
        // { title: '常见问题', action: this.goQuestion }
      ]
      // if (this.feedbackVisible === 'Y') {
      //   // 在第二条插入
      //   _list.splice(1, 0, { title: '反馈评价', action: this.goToEvaluate })
      // }
      return _list
    },
    ...mapState('order', {
      creditStatus: (state) => {
        // 未登录
        if (state.statusCode === '000005') {
          return 'UN_LOGIN'
          // 有逾期账单
        } else if (getKey('userInfo', 'wu') === false) {
          return 'BLACK'
        } else if (state.outlineInfo.sysHasOverdueOrder === true) {
          return 'OVERDUE'
          // 无账单
          // } else if (state.outlineInfo.sysCompleted === true) {
          //     return 'NO_BILL'
          // 系统维护中
        } else if (state.statusCode === '999999') {
          return 'SYSTEM'
        } else if (
          state.outlineInfo.sysOrderLine &&
          state.outlineInfo.sysOrderLine.length > 0
        ) {
          // 有在途订单
          return 'PENDING'
        } else {
          return 'NO_BILL'
        }
      },
      totalAmount: (state) => {
        return state.outlineInfo.sysTotalAmount
      }
    }),
    // 新的服务专区列表
    newItemList () {
      let list = [
        {
          icon: require('./images/icon_jiekuan@2x.png'),
          name: '我的账单',
          action: this.goLoanHistory
        },
        // {
        //   icon: this.showCouponV3Mark === 'Y' && this.showCouponGif ? require('./images/icon_mine_coupon.gif') : require('./images/icon_quanbao@2x.png'),
        //   name: '我的券包',
        //   action: this.goCouponList
        // },
        // {
        //   icon: require('./images/icon_huiyuan@2x.png'),
        //   name: '权益中心',
        //   action: this.goXiaomei
        // },
        {
          icon: require('./images/icon_huankuan@2x.png'),
          name: '三方还款',
          action: this.goParties
        }
        // {
        //   icon: require('./images/icon_fuli@2x.png'),
        //   name: '福利中心',
        //   action: this.welfare
        // },
        // {
        //   icon: require('./images/icon_love2@2x.png'),
        //   name: '猜你喜欢',
        //   action: this.guessLike
        // }

      ]
      // if (this.isQlc) {
      //   const filterList = ['猜你喜欢', '权益中心']
      //   list = list.filter((item) => !filterList.some((name) => item.name === name))
      // }

      if (this.monitor === 'Y') {
        const filterList = ['三方还款']
        list = list.filter((item) => !filterList.some((name) => item.name === name))
      }

      if (['API-rosewallet'].includes(getKey('channel'))) {
        const filterList = ['三方还款', '福利中心', '我的券包']
        list = list.filter((item) => !filterList.some((name) => item.name === name))
      }

      // 根据后端配置再过滤一次
      
      if (this.threeRepayVisible === 'N') {
        list = list.filter((item) => !['三方还款'].some((name) => item.name === name))
      }
     
      return list
    }
  },
  beforeDestroy () {
    clearTimeout(window.timer)
    // 插队申请（至尊王卡）浮标入口已下线，滚动收起监听一并移除
    // const $wrapper = this.$refs['wrapper']
    // $wrapper.removeEventListener('scroll', this.shitCat)
  },
  async created () {
    try {
      await Promise.all([
        this.getUserInfoX({ forceUpdate: true, checkToken: false }),
        this.getOrderOutLine(),
        this.judgeQualification(),
        this.queryXiaomeiIcon(),
        this.getLimitX({ loanPlatform: 'TMD' }),
        this.monitorX()
      ])
      // this.showSkcCheck()
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }

    // 插队申请（至尊王卡）浮标入口已下线，滚动收起监听一并移除
    // this.$nextTick(() => {
    //   const $wrapper = this.$refs['wrapper']
    //   $wrapper.addEventListener('scroll', () => {
    //     this.shitCat()
    //   })
    // })
  },
  async mounted () {
    const res = await this.memberInfo()
    this.getFundPageRoute()
    if (res.success && res.data) {
      // 如果不是会员 跳前置页
      if (!res.data.memberGoodsGroupCd) {
        this.vipStatus = 'novip'
      } else {
        const vips = {
          ENJOY: 'svip',
          LIGHT_ENJOY: 'lvip',
          OLD: 'ovip'
        }
        this.vipStatus = vips[res.data.memberGoodsGroupCd]
      }
    }
    const channel = getKey('channel') || 'official'
    if (this.isIntervalDay(`${channel}HomePopup`, 1)) {
      const { success, data } = await this.queryPopupX({
        showPlace: 'HOME'
      })
      if (success && data) {
        if (data.popupSwitch) {
          // pushState，并且监听popState事件
          window.history.pushState({}, '', window.location.href)
          window.addEventListener('popstate', () => {
            setKey(`${channel}HomePopup`, Date.now())
            this.dialogBackVisible = true
          })
        }
      }
    }
  },
  methods: {
    ...mapActions('user', [
      'logoutX',
      'getUserInfoX',
      'queryXiaomeiIconX',
      'getUserStatus',
      'getLimitX',
      'showStatusX',
      'queryPopupX',
      'fundPageRoute',
      // 插队申请（至尊王卡）浮标入口已下线
      // 'getFloatViewInfo',
      'monitorX'
    ]),
    ...mapActions('order', ['getOrderOutlineX']),
    ...mapActions('activities', ['judgeQualificationX']),
    ...mapMutations('user', ['setUserInfo']),
    ...mapActions('vip', ['memberInfo']),
    ...mapActions(['dataPoint']),

    // 插队申请（至尊王卡）浮标入口已下线
    // shitCat () {
    //   const $cat = document.getElementById('drag')
    //   if ($cat) {
    //     const _left = $cat.style.left
    //     const _top = $cat.style.top
    //     if (!this.catOut) {
    //       this.catOut = true
    //       $cat.setAttribute('style', `left:${_left};top:${_top};transform:translateX(${$cat.offsetLeft > 10 ? '180px' : '-300px'})`)
    //     }
    //     clearTimeout(window.timer)
    //     window.timer = setTimeout(() => {
    //       $cat.setAttribute('style', `left:${_left};top:${_top};`)
    //       this.catOut = false
    //     }, 100)
    //   }
    // },
    // async showSkcCheck () {
    //   const { success, data } = await this.getFloatViewInfo({
    //     showPlace: 'MY'
    //   })
    //   if (success) {
    //     this.floatInfo = data || {}
    //     if (data.kingFloat && data.kingFloat.kingGoodsCd) {
    //       this.$nextTick(() => {
    //         const $skcTop = document.querySelector('.skc-point')
    //         if ($skcTop) {
    //           sessionStorage.setItem(
    //             'dragPosition',
    //             JSON.stringify({ top: $skcTop.offsetTop - 160 + 'px' })
    //           )
    //           this.showSkc = true
    //         }
    //       })
    //     }
    //   }
    // },
    async getFundPageRoute () {
      const { success, data } = await this.fundPageRoute()
      if (success && data) {
        const { memberGoodsCd } = data
        this.memberGoodsCd = memberGoodsCd
      }
    },
    // 查询小美图片
    onBannerChange (index) {
      this.activeBanner = index
    },

    async queryXiaomeiIcon () {
      const res = await this.queryXiaomeiIconX()
      const { success, data } = res || {}
      if (success) {
        this.messageCount = data.messageCount
        this.memberIcon = data.bannerList || []
        this.showCouponV3Mark = data.showCouponV3Mark
        this.showOwn = data.showOwn
      }
      window.timer = window.setTimeout(() => {
        this.showCouponGif = false
      }, 3000)
    },
   
    async judgeQualification () {
      const res = await this.judgeQualificationX()
      const { success, data } = res || {}
      if (success && data) {
        this.isWelfare = true
      }
    },
    openCallDialog () {
      this.$router.push('/service')
      // if (this.creditStatus === 'UN_LOGIN') {
      //   this.goLogin()
      //   return
      // }
      // this.$report({
      //   id: 10058
      // })
      // this.serviceVisible = true
    },

    goLogin () {
      if (hasNativeMethod('navigateTo')) {
        jsBridge('navigateTo', { path: 'login', exitCurrent: true })
      } else {
        this.$router.push('/user/login')
      }
    },
    // 三方还款
    goParties () {
      this.$report({
        id: 10181
      })
      this.$router.push('/repayment/third')
    },
    // 福利中心
    welfare () {
      this.$report({ id: 10185 })
      if (this.isWelfare) {
        this.$router.push('/newWelfare/index')
      } else {
        this.$router.push('/noWelfare/index')
      }
    },
    // 猜你喜欢
    async guessLike () {
      const response = await this.getUserStatus({
        showPlace: 'ALL'
      })
      if (response.success) {
        const { jumpToLoanMarket } = response.data || {}
        this.$report({
          id: 10269,
          args: {
            screen: 'river_diversion',
            step: 'mine',
            status: jumpToLoanMarket ? 'river_diversion' : this.vipStatus
          }
        })
        this.dataPoint({
          id: 10269,
          screen: 'river_diversion',
          step: 'mine',
          status: jumpToLoanMarket ? 'river_diversion' : this.vipStatus
        }) // 同步埋点
        if (jumpToLoanMarket) {
          this.$router.push({
            path: '/river/diversion',
            query: { source: encodeURIComponent(window.location.href) }
          })
        } else {
          const origin = process.env.VUE_APP_PAYURL
          const token = this.userInfo.token
          const channel = getKey('channel') || ''
          setTimeout(() => {
            window.location.href = `${origin}/vip/ssvip/pre?token=${token}&channel=${channel}&refurl=${window.location.origin}`
          }, 300)
          // this.$router.push('/vip/index?target=svip')
        }
      }
    },
    // 关于我们
    goAbout () {
      if (this.creditStatus === 'UN_LOGIN') {
        this.goLogin()
        return
      }
      this.$router.push('/about')
    },
    goToEvaluate () {
      this.$router.push('/feedback/evaluate')
    },
    goToAccountAndSecurity () {
      this.$router.push('/mine/account')
    },
    goMessageList () {
      if (this.creditStatus === 'UN_LOGIN') {
        this.goLogin()
        return
      }
      this.$router.push('/message/list')
    },

    goCouponList () {
      if (this.creditStatus === 'UN_LOGIN') {
        this.goLogin()
        return
      }
      this.$router.push('/quan/list')
    },
    async goMember (url, index) {
      if (url) {
        let curUrl = url.replace(
          /^http[s]?:\/\/tmd.+?\//,
          `${window.location.origin}/`
        )
        window.location.href = curUrl
      }
    },
    // 跳转小美会员
    goXiaomei () {
      const origin = process.env.VUE_APP_PAYURL
      const token = this.userInfo.token
      const channel = getKey('channel') || ''
      window.location.href = `${origin}/vip/ssvip/pre?token=${token}&channel=${channel}&refurl=${window.location.origin}`
    },
    // 去借款历史页面
    goLoanHistory () {
      if (this.creditStatus === 'UN_LOGIN') {
        this.goLogin()
        return
      }
      this.$report({
        id: 10106
      })
      this.$router.push({
        path: '/repayment/history',
        query: {}
      })
    },

    callService () {
      this.$report({
        id: 10061,
        args: {
          position: 'page_page_my',
          target: this.customerServicePhone
        }
      })
      mockHrefJump(`tel:${this.customerServicePhone}`)
    },

    closeDialog () {
      this.$report({
        id: 10062,
        args: {
          postion: 'page_page_my'
        }
      })
    },

    // 获取订单概要
    getOrderOutLine () {
      return this.getOrderOutlineX()
    },

    async logout () {
      this.$report({
        id: 10057
      })
      await this.logoutX()
      this.$statistics('LOGOUT')
      this.setUserInfo({
        token: '',
        mobile: '',
        wu: '',
        name: ''
      })
      localStorage.removeItem('IRR24')
      localStorage.removeItem(CountDownTool.Keys.HomeCountDownEndTime)
      localStorage.removeItem(CountDownTool.Keys.PassCardCountDownTimeStamp)
      this.logoutVisible = false
      if (hasNativeMethod('loginOut')) {
        jsBridge('loginOut')
      }
      if (hasNativeMethod('navigateTo')) {
        jsBridge('navigateTo', { path: 'login', exitCurrent: true })
      } else {
        this.$router.push('/user/login')
      }
    },
    // 跳转问题界面
    goQuestion () {
      this.$router.push('/user/question')
    },

    // 埋点
    buriedPoint () {
      let id = null
      if (this.benefitsStep === 0) {
        id = 10176
      } else if (this.benefitsStep === 0) {
        id = 10177
      } else if (this.benefitsStep === 0) {
        id = 10178
      } else {
        id = 10179
      }
      this.$report({
        id
      })
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

.mine-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.page.mine {
  overflow: hidden;
  background-color: #fafafa;
  padding-bottom: 236px;
  min-height: 100%;

  .support {
    width: 100%;
    height: 20px;
    background: url('../home/images/img_icp@2x.png') no-repeat center center;
    background-size: contain;
    margin:90px auto 30px
  }

  .mt20 {
    margin-top: 20px;
  }

  .banner {
    margin: -110px auto 0;
    width: 750px;
    height: 140px;

    .swipe-item {
      width: 670px;
      height: 110px;
      margin: 0 auto;
    }

    img {
      width: 100%;
      height: 110px;
    }

    .indicator {
      position: absolute;
      bottom: 16px;
      display: flex;
      flex-direction: row;
      left: 50%;
      transform: translateX(-50%);

      .indicator-item {
        width: 16px;
        height: 4px;
        background-color: white;
        opacity: 0.5;
        border-radius: 2px;
        margin-top: -30px;

        &+.indicator-item {
          margin-left: 14px;
        }

        &.active {
          opacity: 1;
        }
      }
    }
  }

  .height300 {
    height: 300px !important;
  }

  .user-info {
    background-color: #43476b;
    height: 370px;

    .info-card {
      width: 750px;
      // height: 280px;
      overflow: hidden;
      position: relative;

      .avatar {
        width: 130px;
        height: 130px;
        margin-top: 100px;
        margin-left: 40px;
        border-radius: 65px;
      }

      .mobile {
        font-size: 42px;
        line-height: 110px;
        top: 87px;
        left: 186px;
        font-weight: 500;
        font-family: DIN-Medium, DIN;
        position: absolute;
        color: white;
      }

      .to-login {
        top: 138px;
        left: 186px;
        position: absolute;
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 56px;
      }

      .tmd-description {
        text-align: center;
        position: absolute;
        width: 170px;
        height: 40px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        background: #575b7f;
        border-radius: 20px;
        vertical-align: middle;
        top: 177px;
        left: 186px;
      }

      .question {
        position: absolute;
        top: 130px;
        right: 140px;
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;

        img {
          width: 36px;
          height: 36px;
        }

        .button {
          margin-top: 15px;
          background-color: transparent;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 28px;
        }
      }

      .login-out {
        position: absolute;
        top: 130px;
        right: 40px;
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;

        img {
          width: 36px;
          height: 36px;
        }

        .button {
          margin-top: 15px;
          background-color: transparent;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 28px;
        }
      }
    }
  }

  .content {
    min-height: 290px;
    border-radius: 3% 3%;
    // margin-top:-50px;
    padding: 0 40px 0;
    overflow: hidden;

    .margin-top24 {
      margin-top: -16px !important;
    }

    .aboutMine {
      margin-top: 24px;
      width: 670px;
      background-color: #fff;
      border-radius: 20px;
      overflow: hidden;

      .navigate-item {
        margin-top: 0px;
        padding-left: 15px;
        padding-right: 17px;
        border-bottom: 1px solid @iuc;
      }
    }

    .items {
      margin-top: 4px;
      width: 670px;
      min-height: 290px;
      padding-bottom: 6px;
      background-color: #fff;
      border-radius: 20px;
      overflow: hidden;

      .services {
        margin: 46px 0px 40px 40px;
        height: 53px;
        font-size: 38px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 53px;
      }

      .item-list {
        width: 670px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        position: relative;
        justify-content: flex-start;

        .item {
          width: 25%;
          // margin: auto;
          margin-top: 0px;
          text-align: center;
          position: relative;
          margin-bottom: 34px;

          .lottie-image {
            width: 60px;
            height: 60px;
            display: inline-block;
          }

          img {
            width: 60px;
            height: 60px;
          }

          .name {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 30px;
          }
          .item-count{
            position: absolute;
            top: -10px;
            left: 98px;
            height: 30px;
            padding: 0 10px;
            background: #ea3826;
            border-radius: 30px;
            color: #fff;
            font-size: 20px;
            line-height: 30px;
          }
          &-point::after {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            right: 45px;
            width: 14px;
            height: 14px;
            background: #ea3826;
            border-radius: 15px;
            border: 3px solid #ffffff;
          }
        }

        .mt34 {
          margin-top: 34px;
        }
      }
    }
  }

  .service-dialog {
    padding-top: 10px;
    padding: 0 48px;
    padding-bottom: 80px;
    font-family: PingFangSC-Regular, PingFang SC;

    .title {
      font-size: 42px;
      height: 72px;
      line-height: 72px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }

    .description {
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin-top: 22px;
      font-weight: 400;
    }

    .description1 {
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin: 12px auto 12px;
      font-weight: 400;
    }

    .telphone {
      font-size: 24px;
      height: 40px;
      line-height: 40px;
      margin-top: 2px;
      font-weight: 400;
      color: @fc3;
    }
  }

  .logout-dialog {
    padding-top: 10px;
    padding: 0 48px;
    padding-bottom: 120px;
    font-family: PingFangSC-Regular, PingFang SC;

    .title {
      font-size: 42px;
      height: 72px;
      line-height: 72px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }

    .description {
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin-top: 22px;
      font-weight: 400;
    }
  }
}
</style>
